import { Loader } from '@fountain/fountain-ui-components';
import React, { useEffect, useState, VFC } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { retrieveKnowledgeBase } from 'containers/ChatAgent/api';
import {
  AxAgentValues,
  KnowledgeBaseResponse,
} from 'containers/ChatAgent/types';
import { addMessageAction } from 'containers/FlashMessage/actions';

import { messages } from '../../messages';
import { AgentContext } from './v3';

export interface KnowledgeBaseProps {
  setAxAgentValues: React.Dispatch<React.SetStateAction<AxAgentValues>>;
  accessToken: string;
  axAgentValues: AxAgentValues;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
  onViewVersionHistory: () => void;
  showVersionHistory: boolean;
  restoreToken?: number;
  onFaqChange?: () => void;
}

export const KnowledgeBase: VFC<KnowledgeBaseProps> = ({
  setAxAgentValues,
  accessToken,
  axAgentValues,
  setIsLoading,
  isLoading,
  onViewVersionHistory,
  showVersionHistory,
  restoreToken,
  onFaqChange,
}) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const [isKnowledgeBaseUploaded, setIsKnowledgeBaseUploaded] =
    useState<boolean>(false);
  const [knowledgeBase, setKnowledgeBase] = useState<KnowledgeBaseResponse>();

  useEffect(() => {
    const fetchKnowledgeBase = async () => {
      setIsLoading(true);
      try {
        const response = await retrieveKnowledgeBase(
          accessToken,
          axAgentValues?.knowledgeBaseUuid as string,
        );
        setKnowledgeBase(response);
      } catch (err) {
        dispatch(
          addMessageAction(
            intl.formatMessage(messages.fetchKnowledgeBaseFailed),
            'error',
          ),
        );
      } finally {
        setIsLoading(false);
      }
    };

    if (axAgentValues.knowledgeBaseUuid) void fetchKnowledgeBase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, isKnowledgeBaseUploaded]);

  if (isLoading) return <Loader fullScreen size="2rem" />;

  return (
    <AgentContext
      setAxAgentValues={setAxAgentValues}
      accessToken={accessToken}
      axAgentValues={axAgentValues}
      knowledgeBase={knowledgeBase}
      isKnowledgeBaseUploaded={isKnowledgeBaseUploaded}
      setIsKnowledgeBaseUploaded={setIsKnowledgeBaseUploaded}
      onViewVersionHistory={onViewVersionHistory}
      showVersionHistory={showVersionHistory}
      restoreToken={restoreToken}
      onFaqChange={onFaqChange}
    />
  );
};

export default KnowledgeBase;
